import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Form, Input, Row, Spin, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";
import { IoArrowBack } from "react-icons/io5";


class BriefingNotaForm extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'add' ? 'Adicionar' : 'Editar',
        defaultValue: null,
        doc: false,
        fileList: [],
        filters: { NOTE_CATEGORY_ID: [] }
    }

    back = String(this.props.url).replace(':id', this.state._params[8]);
    back2 = this.props.ret;

    componentDidMount = () => {
        titleWeb('Briefing | Nota')
        if (this.props.type === 'add') {
            this.setState({_screen: false})
        } else if (this.props.type === 'edit') {
            this.onView()
        }
    }

    onView = async () => {
        var filter = { ID: this.state._params[8], NOTE_ID: this.state._params[6] }
        POST_API('/note_body/search.php', { token: getToken(), type: 'view', filter: JSON.stringify(filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        values.NOTE_ID = this.state._params[8]
        POST_API('/note_body/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    render = () => {

        const routes = this.props.bread

        if (this.state._navigate) {
            return (<Navigate to={this.back} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to={this.back2}><FloatButton className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} align={'bottom'}>
                        { this.state._screen ? <Col span={24}><center><Spin /></center></Col> : (
                            <Col span={24}>
                                <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]}>
                                        <Col md={24} xs={24}>
                                            <Form.Item label="Nota" name="BODY" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input.TextArea rows={8} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        )

    }

}

export default BriefingNotaForm;